

export const initialState = {
    connectorUid:'',
    cancelUpload:'inProgress',
    uid:'',
    step : 'Enter DB Info',
    page:'Assemble Input Source',
    files:[],
    dataPreview:[],
    template:0,
    addColumns:[],
    dataMapping:[],
    suggestions:[],
    table:[],
    orderName:[],
    extraColumns:[],
}